import axios from './_axios';
import entrypoints from './_entrypoints';
import { getData, reduceWidgetGroupsToNewsGroups, reduceWidgetGroupsToNewspapers, dateToApiDate } from '../shared/functions';
/**
 * API call to retrieve a collection of newspapers
 * @return {Promise<Newspaper[]>}
 */
var getNewspapersForDate = function (date) { return axios
    .get(entrypoints.widget, { params: { date: dateToApiDate(date) } })
    .then(getData)
    .then(function (data) { return [reduceWidgetGroupsToNewspapers(data), reduceWidgetGroupsToNewsGroups(data)]; }); };
export default getNewspapersForDate;
